import { render, staticRenderFns } from "./NotificationsMenu.vue?vue&type=template&id=9076e5f0"
import script from "./NotificationsMenu.vue?vue&type=script&lang=js"
export * from "./NotificationsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports